module.exports = __webpack_public_path__ + "static/img/piliangshanchu2.5bc70e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/piliangshanchu2.png
// module id = wepC
// module chunks = 24